module.exports = __webpack_public_path__ + "img/icon_newspaper.d908543b.svg";